export default "./dist/stdassets/images/icons/icon_warning.png";